module.exports = __webpack_public_path__ + "static/scale-model-of-wise-wonders-children's-museum-in-billings-montana-78da069c49093e894705f3e6e5928665.png";